import {
  type DialogProps,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  DialogActions,
  Button,
  CopyToClipboard,
  ContentCopyRoundedIcon,
  ReadonlyField,
  Flex,
} from '@shared/components';

interface AnnouncementDetailsModalProps extends DialogProps {
  onClose: () => void;
  announcement: {
    title: string;
    link: string;
  } | null;
}

export default function AnnouncementDetailsModal(props: Readonly<AnnouncementDetailsModalProps>) {
  const { open, onClose, announcement } = props;

  return (
    <Dialog open={open}>
      <DialogTitle onClose={onClose}>รายละเอียดประกาศข่าวสาร</DialogTitle>
      <Divider />
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: (theme) => theme.spacing(6),
          gap: (theme) => theme.spacing(4),
        }}
      >
        <ReadonlyField label='หัวข้อประกาศ' maxLines={2} content={announcement?.title ?? ''} />
        <ReadonlyField
          label='แนบลิงก์อ้างอิง'
          content={
            <Flex sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
              {announcement?.link ?? ''}
              <CopyToClipboard as='span' text={announcement?.link ?? ''}>
                <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
              </CopyToClipboard>
            </Flex>
          }
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button size='large' onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
